export default __webpack_public_path__ + "static/media/standard_06.1cfc7dcf.png";